<template>
    <div class="page">
        <div class="work_body">
            <div class="top_label">
                <span class="lable_name">作业管理</span>
                
            </div>
            <div class="label_button_box">
                
                <span @click="changeWorkType(0)" :class="{active:form_data.work_type == 0}">周期作业</span>
                <span @click="changeWorkType(1)" :class="{active:form_data.work_type == 1}">临时作业</span>
            </div>
            <!-- <Skeleton v-if="loading" :skeleton_type="'image_text'"></Skeleton> -->

            <div class="work_top_statitsc">

                <div class="work_top_statitsc_item">
                    <div class="work_top_statitsc_item_left">
                        <span class="name">已布置作业</span>
                        <span class="number">{{top_statistics.work_count}}次</span>
                    </div>
                    <div class="work_top_statitsc_item_right">
                        <span>
                            <el-icon class="el-icon-s-opportunity"></el-icon>
                        </span>
                    </div>
                </div>
                <div class="work_top_statitsc_item">
                    <div class="work_top_statitsc_item_left">
                        <span class="name">完成人数</span>
                        <div class="number_box">
                            <span class="number">{{top_statistics.complete_count}}人</span>
                            <!-- <span class="unit">完成率 {{top_statistics.complete_rate}}%</span> -->
                        </div>
                        
                    </div>
                    <div class="work_top_statitsc_item_right">
                        <span style="color: #9333ea;background: #f3e8ff;">
                            <el-icon class="el-icon-s-custom"></el-icon>
                        </span>
                    </div>
                </div>
                <div class="work_top_statitsc_item">
                    <div class="work_top_statitsc_item_left">
                        <span class="name">平均分</span>
                        <span class="number">{{top_statistics.total_avg_fraction}}分</span>
                    </div>
                    <div class="work_top_statitsc_item_right">
                        <span style="color: #67C23A;background: #E1F3D8;">
                            <el-icon class="el-icon-s-data"></el-icon>
                        </span>
                    </div>
                </div>
                <div class="work_top_statitsc_item">
                    <div class="work_top_statitsc_item_left">
                        <span class="name">任务完成率</span>
                        <span class="number">{{top_statistics.complete_rate}}%</span>
                    </div>
                    <div class="work_top_statitsc_item_right">
                        <span style="color: #F56C6C;background: #FDE2E2;">
                            <el-icon class="el-icon-message-solid"></el-icon>
                        </span>
                    </div>
                </div>
                <div class="work_top_statitsc_item">
                    <div class="work_top_statitsc_item_left">
                        <span class="name">做题人数</span>
                        <span class="number">{{top_statistics.submit_user}}人</span>
                    </div>
                    <div class="work_top_statitsc_item_right">
                        <span style="color: #E6A23C;background: #FAECD8;">
                            <el-icon class="el-icon-s-claim"></el-icon>
                        </span>
                    </div>
                </div>

            </div>
            <div class="Tasklistchart_box">
                <span class="Tasklistchart_box_title">学生做题统计</span>

                <div class="Tasklistchart_box_chart">
                    <Tasklistchart :type="0" :work_type="form_data.work_type"></Tasklistchart>
                </div>
            </div>

            <div class="task_box_list_title">
                <span class="task_box_list_title_text">任务列表</span>
                <div>
                    <el-button icon="el-icon-edit" size="small" @click="$router.push({name:'Cyclework'})" type="primary">布置周期作业</el-button>
                    <el-button icon="el-icon-edit" size="small" @click="$router.push({name:'Temporary'})" type="primary" plain>布置临时作业</el-button>
                </div>
            </div>
            
            <div class="impot_excel_box">
                <el-checkbox-group v-model="excelHeaders">
                    <el-checkbox v-for="(item,index) in file_form" :disabled="isDisabled(index)" :key="index" :label="index">{{ item }}</el-checkbox>
                </el-checkbox-group>
                <div class="label_button_box_right">
                    <div class="label_button_box_right_item">
                        <el-input v-model="numbers" style="width:300px" :clearable="true" placeholder="设置篇数"></el-input>
                        <el-button @click="importTotalFile" type="primary" class="el-icon-download"> 导出成绩</el-button>
                    </div>
                    
                    <div class="label_button_box_right_text">* 设置篇数导出系统成绩最高的XX篇, 不设置篇数则导出全部</div>
                </div>
            </div>

            <el-input v-model="form_data.keyword" :clearable="true" @input="changKeyword" style="margin-top:25px" placeholder="请输入作业名称"></el-input>
            <div class="task_box">
                <el-checkbox-group v-model="changePlan">

                    <div v-for="item in work_list" :key="item.id" class="task_box_item">

                        <div class="task_box_item_top">
                            <el-checkbox :label="item" :key="item.id">{{item.name}}</el-checkbox>
                            <!-- <span class="task_name">{{item.name}}</span> -->
                            <el-tag size="small" :type="item.status === 0 || item.status === 1 ? 'danger' : 'primary'">{{item.status_text}}</el-tag>
                        </div>
                        <span class="task_info">{{item.plan_name}}</span>
                        <div class="task_box_item_tag">
                            <el-tag size="small" v-if="item.read_number" type="danger">阅读在线{{item.read_number}}篇</el-tag>
                            <el-tag size="small" v-if="item.specialty_number" type="primary">应试英语{{item.specialty_number}}篇</el-tag>
                        </div>
                        <div class="task_box_item_time">
                            <i class="el-icon-date"></i>
                            <span>{{item.start_time}} ~ {{item.end_time}}</span>
                        </div>
                        <div class="task_box_item_progress">
                            <div class="task_box_item_progress_text">
                                <span>学生总人数：{{item.total_student}}人</span>
                                <span>完成人数：{{item.complete_count}}人</span>
                            </div>
                            <el-progress style="margin-top: 10px;" :show-text="false" :stroke-width="8" :color="item.complete_rate < 50 ? '#F56C6C' : '#409EFF'" :percentage="item.complete_rate"></el-progress>
                        </div>
                        <div class="task_box_item_buttom">
                            <div @click="importStudentWork(item)">
                                <i class="el-icon-download"></i>
                                <span>导出作业</span>
                            </div>
                            <div @click="importWork(item)">
                                <i class="el-icon-download"></i>
                                <span>导出材料</span>
                            </div>
                            <div @click="imworkExcel(item)">
                                <i class="el-icon-download"></i>
                                <span>导出成绩</span>
                            </div>
                            <div @click="$router.push({name:'Worklist',query:{plan_id:item.plan_id,plan_name:item.name,task_id:item.id,type:form_data.work_type}})">
                                <i class="el-icon-monitor"></i>
                                <span>查看详细</span>
                            </div>
                            <div @click="delWork_(item)" class="task_del_button" type="danger">
                                <i class="el-icon-delete"></i>
                                <span>删除</span>
                            </div>
                        </div>
                    </div>
                </el-checkbox-group>
            </div>
            <el-empty v-if="!work_list.length" description="暂无作业"></el-empty>
            <div class="pagition_box">
                <el-pagination background layout="prev, pager, next" hide-on-single-page :total="total" :page-size="form_data.pageSize" @current-change="changeNumber" @prev-click="prev" @next-click="next" />
            </div>
            
        </div>
    </div>
</template>
<script>
import Http from "../../apis/teach";
import Work from "../../apis/work";
import Tasklistchart from "../../../untils/chart/tasklistchart.vue";
import skeleton from "../../../untils/skeleton.vue";
export default {
    components:{
        'Skeleton':skeleton,
        Tasklistchart
    },
    data(){
        return{
            numbers:'',
            excelHeaders:['name','stuid','low_rate','high_rate','average_rate'],
            checDisList:['name','stuid','low_rate','high_rate','average_rate'],
            //checkList:['name','stuid','low_rate','high_rate','average_rate'],
            file_form:{'name':'姓名','stuid':'学号','low_rate':'最低正确率','high_rate':'最高正确率','average_rate':'平均正确率','score':'得分','read_number':'阅读做题数','read_rate':'阅读正确率','specialty_number':'应试做题数','specialty_rate':'应试正确率','time':'耗时','detail':'做题材料'},
            workfile_form:{'name':'姓名','stuid':'学号','low_rate':'最低正确率','high_rate':'最高正确率','average_rate':'平均正确率','score':'得分','read_number':'阅读做题数','read_rate':'阅读正确率','specialty_number':'应试做题数','specialty_rate':'应试正确率','time':'耗时','detail':'做题材料'},
            changePlan:[],
            loading:true,
            plan_data:[],
            form_data:{
                page:1,
                pageSize:9,
                keyword:'',
                work_type:0
            },
            total_number:0,
            keyword:'',
            work_list:[],
            total:0,
            top_statistics:{}
        }
    },
    created() {
        //this.getList()
        this.workList()
        this.workTopfStatistics()
    },
    activated() {

        //this.getList()
        
    },
    methods:{
        changeWorkType(type){
            this.form_data.work_type = type
            this.workList()
            this.workTopfStatistics()
        },
        workList(){
            Http.workList(this.form_data).then((res) => {
                this.work_list = res.data.list
                this.total = res.data.total
            });
        },
        
        workTopfStatistics(){
 
            Http.workTopfStatistics({work_type:this.form_data.work_type}).then((res) => {
                this.top_statistics = res.data
            });
        },
        isDisabled(index) {
            var checDisList = JSON.parse(JSON.stringify(this.checDisList))

            for(var i in checDisList){

                if(index == checDisList[i]){
                    return true
                }
            }

        },
        delWork_(item){
            var _this = this
            this.$confirm('删除后不可恢? 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                console.log(111)
                
                _this.delWorkOPtion(item)
            }).catch(() => {
                console.log(222)
                this.$message({
                    type: 'info',
                    message: '操作已取消'
                });          
            });
            

        },
        delWorkOPtion(item){
            var params = {}
            params.task_id = item.id
            params.plan_id = item.plan_id
            Work.delWork(params).then((res) => {
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: res.code ? 'success' : 'error'
                });
                this.workList()
            });
        },

        importStudentWork(item){
        
            const fileUrl = `${this.$Server.tempHost}/api/teachwork/importStudentWork?task_id=${item.id}&plan_id=${item.plan_id}`;
            
            // 新开窗口下载
            const downloadWindow = window.open(fileUrl, '_blank');
            
            // 监听窗口关闭/加载完成
            const checkWindow = setInterval(() => {
                if (downloadWindow.closed) {
                clearInterval(checkWindow);
                this.$message.success('下载窗口已关闭');
                } else if (downloadWindow.document.readyState === 'complete') {
                clearInterval(checkWindow);
                // 可以在这里添加下载完成的处理逻辑
                }
            }, 1000);
            
            // 添加下载状态提?
            this.$message.info('正在准备下载文件，请稍后..');
            
        },

        importWork(item){
            const fileUrl = `${this.$Server.tempHost}/api/teachwork/importWork?task_id=${item.id}&plan_id=${item.plan_id}`;  

            window.open(fileUrl, '_blank');
        },
        imworkExcel(item){
            const fileUrl = `${this.$Server.tempHost}/api/teachwork/imworkExcel?task_id=${item.id}&plan_id=${item.plan_id}&work_type=${this.form_data.work_type}`;  

            window.open(fileUrl, '_blank');
        },
        getList(){
            // const loading = this.$loading({
            //     lock: true,
            //     text: '疯狂加载中..',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.5)'
            // });
            var params = this.form_data
            params.keyword = this.keyword
            Http.PlanList(params).then((res) => {
                this.loading = false
                //loading.close()
                this.plan_data = res.data.list
                this.total_number = res.data.count
            });
        },
        importTotalFile(){
            
            let plan_id = []
            let task_id = []
            for(var i in this.changePlan){
                plan_id.push(this.changePlan[i].plan_id)
                task_id.push(this.changePlan[i].id)
            }
  
            // 文件的直接下载链接  
            if(!this.changePlan.length){
                this.$message({
                    type: 'error',
                    message: '请选择班级'
                });
                return
            }
            var params = this.excelHeaders
            var condition = {}
            for(var index in params){
                condition[params[index]] = true
            }
            condition.plan_id = plan_id.join(',')
            condition.type = this.form_data.work_type == 0 ? 1 : 2
            condition.task_id = task_id.join(',')
            condition.numbers = this.numbers
            const fileUrl = `${this.$Config.baseUrl}/api/teachgrades/import?token=${window.sessionStorage.getItem("token")}&${this.$Common.objectToQueryString(condition)}`;  
            
            window.open(fileUrl, '_blank')
        },
        // 上一页

        prev(e){
            this.form_data.page = e
            this.workList()
        },

        // 下一页
        next(e){
    
            this.form_data.page = e
            this.workList()
        },

        // 点击页码
        changeNumber(e){
            this.form_data.page = e
            this.workList()
        },

        // 前往指定页数
        changeSize(e){
            this.form_data.page = e
            this.workList()
        },
        // 搜索班级
        changKeyword(value){
            this.form_data.keyword = value
            this.workList();
        }
    }
}
</script>

<style scoped>

.top_label{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.impot_excel_box{
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    margin-top: 20px;
}
.label_button_box_right{
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 20px;
}
.label_button_box_right_item{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
}
.label_button_box_right_text{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: red;
    font-size: 12px;
}
.top_label >>> .el-input{
    width: 200px;
}
.lable_name{
    font-size: 19px;
    font-weight: 700;
}
.label_button_box{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 15px;
    margin-top: 25px;
}
.label_button_box span{
    padding: 7px 15px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 6px;
    
    font-size: 18px;
    font-size: 14px;
}
.label_button_box .active{
    background: #409eff !important;
    color: #fff !important;
}



.work_top_statitsc{
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
    margin-top: 20px;
}
.work_top_statitsc_item{
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.work_top_statitsc_item_left{
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 25px;
}
.work_top_statitsc_item_left .unit{
    font-size: 12px;
    color: #F56C6C;
}
.work_top_statitsc_item_left .name{
    font-size: 14px;
    font-weight: 700;
}
.work_top_statitsc_item_left .number{
    font-size: 18px;
    font-weight: 700;
}
.work_top_statitsc_item_left .number_box{
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 10px;
}



.work_top_statitsc_item_right{
    display: flex;
    align-items: center;
}

.work_top_statitsc_item_right span{
    padding: 12px;
    display: flex;
    align-items: center;
    background: #D9ECFF;
    border-radius: 50%;
    color: #409eff;
    font-size: 18px;
}
.Tasklistchart_box{
    width: 100%;
    display: inline-block;
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.Tasklistchart_box_title{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
}
.task_box >>> .el-checkbox-group{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 20px;
}
.task_box_item{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.task_box_item .task_info{
    display: flex;
    justify-content: flex-start;
    
    font-size: 13px !important;
}

.task_box_item_top >>> .el-checkbox{
    
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
}
.task_box_item_top >>> .el-checkbox__label{
    font-size: 16px;
    font-weight: 700;
    color: #000;
}

.task_box_item_tag{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}
.task_box_item_time{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    gap: 5px;
}
.task_box_item_time .el-icon-date{
    color: #409eff;
    margin-top: -1px;
}
.task_box_item_time span{
    opacity: 0.7;
}
.task_box_item_progress{
    width: 100%;
}
.task_box_item_progress_text{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
}

.task_box_item_top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    width: 100%;
}
.task_box_item_top .task_name{
    font-size: 15px;
    font-weight: 700;
}
.task_box_item_buttom{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 5px;
    width: 100%;
    margin-top: 10px;
}
.task_box_item_buttom div{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    font-size: 12px;
    padding: 7px 9px;
    border-radius: 6px;
    color: #409eff;
    background: #D9ECFF;
}
.task_box_item_buttom div i{
    margin-top: 1px;
}

.task_box_item_buttom .task_del_button{
    background: #FDE2E2 !important;
    color: #F56C6C !important;
}
.task_box_list_title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    margin-top: 25px;
}
.task_box_list_title_text{
    font-size: 16px;
    font-weight: 700;
}
.Tasklistchart_box_chart{
    width: 100%;
    height: 300px;
}
.pagition_box{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 30px;
}
</style>